import { ImageShape } from '@/types';
import dynamic from 'next/dynamic';
import ButtonBack from '@/components/shared/ButtonBack';

const Image = dynamic(() => import('next/image'));

type Props = {
    name: string;
    image: ImageShape;
};

const ArticleHero = ({ name, image }: Props) => {
    return (
        <div className="article-hero wrapper">
            <ButtonBack fallbackHref="/blog" />
            <div className="article-hero__inner article-wrapper">
                <div className="article-title h1">{name}</div>
            </div>
            <div className="article-hero__image">
                <Image src={image.src} alt={image.alt ?? ''} width={image.width} height={image.height} />
            </div>
        </div>
    );
};

export default ArticleHero;
